import React from 'react';
import { HeadSection } from './sections/head-section';
import WatchComfort from './sections/watch-comfort';
import { Comfort } from './sections/comfort';
import { ConnectRequest } from './sections/connect-request';
import { Subscriptions } from './sections/subscription';
import { WatchNow } from './sections/watch-now';
import * as ST from './sections/styled';


export const Look = () => {
    return (
        <ST.DomruInternet>
            <HeadSection />
            <WatchNow />
            <Comfort />
            <Subscriptions />
            <WatchComfort/>
            <ConnectRequest />

        </ST.DomruInternet>
    );
};
